'use strict';//Indicating browser should run only in java script mode

var EMRMergeClientMedInventoryModule = angular.module('EMR.MergeClientMedInventoryModule', []);